import { Component, OnDestroy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { environment } from '@environments/environment';
import { NavbarComponent } from '@app/shared/layout/navbar/navbar.component';
import { routeToTenantId } from '@app/config/auth-constants';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

// Routes where the global navbar should be hidden (pages with their own header or no navbar)
const NAVBAR_HIDDEN_ROUTES = ['/signup', ...Object.keys(routeToTenantId).map(r => `/${r}`)];

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NavbarComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnDestroy {
  showNavbar = true;
  private routerSubscription?: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
  ) {
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      const rawUrl = (event as NavigationEnd).urlAfterRedirects || (event as NavigationEnd).url;
      const pathname = new URL(rawUrl, window.location.origin).pathname;
      this.showNavbar = !NAVBAR_HIDDEN_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'));
    });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && environment.bugHerdApiKey) {
      const bugHerdScriptTag = document.createElement('script');

      bugHerdScriptTag.type = 'text/javascript';
      bugHerdScriptTag.src = `https://www.bugherd.com/sidebarv2.js?apikey=${environment.bugHerdApiKey}`;
      bugHerdScriptTag.async = true;

      document.head.appendChild(bugHerdScriptTag);
    }
  }
}
